<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>تقارير التحصيلات</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض بعض تقارير التحصيلات
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class="col-lg-10 col-md-9 col-sm-12">
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <label>الفرع</label>
                  <select  @change='FillItineraries()' class="form-control"  v-model="brancheID">
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <label>المنطقة:</label>
                  <select class="form-control" style="padding: 0px" v-model="region_id">
                    <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.region_name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <div class="form-group">
                    <label>المطلوب</label>
                    <select class="form-control" v-model="typeID">
                      <option value='-1'>شمم</option>
                      <option value='0'>اقساط مستهدفة</option>
                      <option value='1'>اقساط محققة</option>
                      <option value='2'>اقساط متاخره </option>
                      <option value='3'>حالة الأقساط</option>
                    </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-4 col-sm-6'>
                  <label>&nbsp;</label>
                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                    <b> عرض </b>
                  </button>
                </div>
                <div v-show="typeID == 3" class='col-lg-3 col-md-3 col-sm-6'>
                  <label>العرض</label>
                  <select class="form-control"  v-model="displayTypeID" >
                    <option v-for="item in displayType" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-2 col-md-3 col-sm-12" style="padding: 0px">
                <!-- /.panel -->
                <div class="chat-panel panel panel-default" >
                  <div class="panel-heading">
                    الخطوط
                  </div>
                  <!-- /.panel-heading -->
                  <div class="panel-body" style="padding: 5px">
                    <div v-for="(item,index) in lines" v-bind:key="index" >
                      <input @click="FillRegions($event)" :id="index" type="checkbox" :value="item.id" v-model="selectedLine">{{' ' + item.name }}
                    </div>
                  </div>
                  <!-- /.panel-body -->
                </div>
              </div>
              <div  v-show="typeID < 2" style="padding:10px">

                <div class='col-lg-6 col-md-6 col-sm-6'>
                  العدد: {{SumCount}}
                </div>
                <div class='col-lg-6 col-md-6 col-sm-6'>
                  الاجمالى: {{sumAmount}}
                </div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>التاريخ</th>
                      <th style='padding:2px;text-align: center'>العدد</th>
                      <th style='padding:2px;text-align: center'>المبلغ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td align='center'>{{record.date}}</td>
                      <td align='center'>{{record.count}}</td>
                      <td align='center'>{{record.amount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div  v-show="typeID == 2" style="padding:10px">
                <div class='col-lg-6 col-md-6 col-sm-6'>
                  العدد: {{records.length}}
                </div>
                <div class='col-lg-6 col-md-6 col-sm-6'>
                  الاجمالى: {{sumAmount}}
                </div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>الكود</th>
                      <th style='padding:2px;text-align: center'>الاسم</th>
                      <th style='padding:2px;text-align: center'>التاريخ</th>
                      <th style='padding:2px;text-align: center'>المبلغ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.due_date}}</td>
                      <td align='center'>{{record.amount}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div  v-show="typeID == 3" style="padding:10px">
                <div class='col-lg-6 col-md-6 col-sm-6'>
                  العدد: {{filteredRecords.length}}
                </div>
                <div class='col-lg-6 col-md-6 col-sm-6'>
                  الاجمالى: {{sumAmount}}
                </div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>الكود</th>
                      <th style='padding:2px;text-align: center'>الاسم</th>
                      <th style='padding:2px;text-align: center'>التاريخ</th>
                      <th style='padding:2px;text-align: center'>المبلغ</th>
                      <th style='padding:2px;text-align: center'>المسدد</th>
                      <th style='padding:2px;text-align: center'>الباقى</th>
                      <th style='padding:2px;text-align: center'>الايصال</th>
                      <th style='padding:2px;text-align: center'>الحالة</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in filteredRecords' :key='index'>
                      <td align='center'>{{record.rec_id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.due_date}}</td>
                      <td align='center'>{{record.amount}}</td>
                      <td align='center'>{{record.total_paid}}</td>
                      <td align='center'>{{record.rest}}</td>
                      <td align='center'>{{record.id}}</td>
                      <td align='center'>{{record.type}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.fcolor {
   color: #CC0000;
}
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'createCollectingstatement',
  components: {
    tbDate
  },
  data () {
    return {
      displayType: [{id: -3, name: 'الكل'}, {id: -2, name: 'مدفوع بدون ايصال'}, {id: -1, name: 'غير مصدر'}, {id: 0, name: 'مصدر'}, {id: 1, name: 'مرتجع'}, {id: 2, name: 'موزع'}, {id: 3, name: 'ملغى'}, {id: 4, name: 'مسوى'}, {id: 5, name: 'مفقود'}],
      displayTypeID: -3,
      sumAmount: 0,
      SumCount: 0,
      typeID: 0,
      today: true,
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: '',
      emptyRec: [{id: 0, name: 0}],
      validationErrors: '',
      offers: {},
      pagination: {},
      region_id: {},
      regions: '',
      records: {},
      lines: {},
      line: '',
      selectedLine: [],
      record: {},
      isLoadingData: false,
      printRecords: [],
      branches: {},
      governorates: {},
      cities: {},
      itineraries: {},
      tabName: 'إدراج',
      title: '',
      brancheID: 0,
      itinerarie: 0
    }
  },
  computed: {
    filteredRecords () {
      if (this.records) {
        if (this.displayTypeID > -3) {
          return this.records.filter(item => item.status === this.displayTypeID)
        } else {
          return this.records
        }
      }
    }
  },
  watch: {
    filteredRecords (rec) {
      this.sumAmount = 0
      for (let i in rec) { this.sumAmount += Number(rec[i].amount) }
    }
  },
  created () {
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
    this.governorates.unshift(this.emptyRec)
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.branch = this.branches[0].id
    this.FillItineraries()
  },
  methods: {
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
      if (i > -1) {
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    FillRegions (e) {
      this.$nextTick(() => {
        var id = (this.selectedLine[0])
        this.regions = ''
        this.region_id = ''
        if (id != null && id.length !== 0) {
          let r = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
          let i = this.branches[r].itineraries.findIndex(x => x.id === parseInt(id))
          if (i > -1) {
            this.regions = JSON.parse(JSON.stringify(this.branches[r].itineraries[i].regions))
            this.regions.unshift(this.emptyRec)
          }
        }
      })
    },
    GetData () {
      this.isLoadingData = true
      this.sumAmount = 0
      this.SumCount = 0
      this.validationErrors = ''
      axios.post(this.$apiURL + 'get-rep01', {
        token: localStorage.getItem('token'),
        type_id: this.typeID,
        branche_id: this.brancheID,
        from_date: this.from_date,
        to_date: this.to_date,
        region_id: this.region_id,
        selectedLine: this.selectedLine
      })
        .then(res => {
          this.isLoadingData = false
          this.records = res.data
          var i
          for (i in this.records) { this.sumAmount += Number(this.records[i].amount) }
          for (i in this.records) { this.SumCount += Number(this.records[i].count) }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/Rep01.vue